/* Cloudwear — Black Week 2026 (11.2026): jeden licznik, jedna data.
   Konfiguracja w window.cwPromo (layout/theme.liquid z ustawień motywu „Promocja”):
   end (ISO 8601 z offsetem — czas absolutny, klientka w innej strefie widzi ten sam
   moment), afterText (pasek po zakończeniu), strings (locales/*.json).
   Elementy: [data-cw-countdown="bar|full|pdp"] dostają tekst fazy:
     > 48 h  → „Koniec za 11 dni” (pdp: nic)
     24–48 h → „Koniec jutro o 23:59”
     < 24 h  → „Koniec dziś o 23:59” (+ „zostało 5 godz. 12 min”, gdy < 6 h, tryb full/pdp)
   Po terminie: html.cw-promo-over (CSS chowa [data-cw-promo]), [data-cw-promo-after]
   dostaje afterText. Liquid jest cache'owany — to JS jest źródłem prawdy o końcu.
   Elementy odpytywane przy każdym ticku (koszyk re-renderuje się przez Section Rendering). */
(function () {
  var cfg = window.cwPromo;
  if (!cfg || !cfg.end) return;
  var end = new Date(cfg.end).getTime();
  if (isNaN(end)) return;
  var s = cfg.strings || {};
  var H = 3600000;
  var D = 86400000;
  var over = false;
  var timer;
  var endTime = cfg.endTime || '23:59';

  function pluralDays(n) {
    var form;
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (n === 1) form = s.daysOne;
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) form = s.daysFew || s.daysOther;
    else form = s.daysMany || s.daysOther;
    return (form || '[n] dni').replace('[n]', n);
  }
  function fmtLeft(rem) {
    var h = Math.floor(rem / H);
    var m = Math.floor((rem % H) / 60000);
    var hu = s.hoursShort || 'godz.';
    var mu = s.minShort || 'min';
    if (h > 0) return m > 0 ? h + ' ' + hu + ' ' + m + ' ' + mu : h + ' ' + hu;
    return Math.max(m, 1) + ' ' + mu;
  }
  function phaseText(rem, mode) {
    if (rem >= 48 * H) {
      if (mode === 'pdp') return '';
      return (s.endsIn || 'Koniec za [time]').replace('[time]', pluralDays(Math.floor(rem / D)));
    }
    if (rem >= 24 * H) return (s.endsTomorrow || 'Koniec jutro o [time]').replace('[time]', endTime);
    var today = (s.endsToday || 'Koniec dziś o [time]').replace('[time]', endTime);
    if (mode !== 'bar' && rem < 6 * H) {
      return today + ' · ' + (s.left || 'zostało [time]').replace('[time]', fmtLeft(rem));
    }
    return today;
  }
  function finish() {
    over = true;
    window.clearTimeout(timer);
    /* slajdy tylko-promocyjne paska (dostawa gratis) wypadają z DOM, żeby :nth-child tickera
       policzył się od nowa (2 slajdy → własny cykl 8 s w cloudwear-promo.css) */
    var ps = document.querySelectorAll('.slider__slide[data-cw-promo]');
    for (var j = 0; j < ps.length; j++) ps[j].parentNode.removeChild(ps[j]);
    document.documentElement.classList.add('cw-promo-over');
    var afters = document.querySelectorAll('[data-cw-promo-after]');
    for (var i = 0; i < afters.length; i++) {
      if (cfg.afterText) afters[i].textContent = cfg.afterText;
      afters[i].hidden = false;
    }
  }
  function render() {
    var rem = end - Date.now();
    if (rem <= 0) { finish(); return; }
    var els = document.querySelectorAll('[data-cw-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var txt = phaseText(rem, el.getAttribute('data-cw-countdown') || 'full');
      if (el.textContent !== txt) el.textContent = txt;
      /* pdp: span pusty poza ostatnimi 48 h — separator „·” siedzi w CSS (::before) */
      el.hidden = txt === '';
    }
    /* częściej tylko w ostatniej godzinie; cyfry minutowe wystarczą */
    window.clearTimeout(timer);
    timer = window.setTimeout(render, rem < H ? 15000 : 30000);
  }
  render();
  /* Theme Editor / Section Rendering: nowe elementy łapie kolejny tick;
     po przeładowaniu sekcji odświeżamy od razu, żeby nie było pustego spanu */
  document.addEventListener('shopify:section:load', function () { if (!over) render(); });
})();
